import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import remarkGfm from 'remark-gfm'

interface MarkdownViewerProps {
  content: string
  className?: string
  limitLines?: number
}

const Mention = ({ id, children }: { id?: string; children: React.ReactNode }) => {
  return (
    <span
      className='inline-flex items-center px-1.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 border border-blue-200 cursor-default'
      title={`User ID: ${id}`}
    >
      {children}
    </span>
  )
}

export const MarkdownViewer = ({ content, className = '', limitLines }: MarkdownViewerProps) => {
  const lineClampStyle: React.CSSProperties = limitLines
    ? {
        display: '-webkit-box',
        WebkitLineClamp: limitLines,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
      }
    : {}

  return (
    <div
      className={`prose prose-sm max-w-none break-words ${className}`}
      style={lineClampStyle}
      title={limitLines ? content : undefined}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw]}
        components={{
          // Handle <span> with data-type="mention" (emitted by Tiptap)
          span: ({ node, ...props }) => {
            const data = props as Record<string, unknown>
            if (data['data-type'] === 'mention') {
              return <Mention id={data['data-id'] as string}>{props.children}</Mention>
            }
            return <span {...props} />
          },
          // Ensure links open in new tab
          a: ({ node, ...props }) => (
            <a
              {...props}
              target='_blank'
              rel='noopener noreferrer'
              className='text-blue-600 hover:underline'
            />
          ),
          // Clean up paragraph margins for small blocks
          p: ({ node, ...props }) => <p {...props} className='mb-2 last:mb-0' />,
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  )
}
